import React from 'react';
import {CMSBuilderProvider} from '../contexts/CMSBuilderContext';
import TinaConfig from '../tinacms/containers/TinaConfig';
import PropTypes from 'prop-types';
import {PageProvider} from '../contexts/PageContext';


/**
 * This container is the one that put in place
 * all the context and configurations that require tina
 * @author Yadian
 * @since v0.0.1
 * */
const CMSProvider = ({children, initSettings, NotFound}) => {

  return (
    <PageProvider languages={initSettings.languages}>
      <TinaConfig initSettings={initSettings}>
        <CMSBuilderProvider NotFound={NotFound}>
          {children}
        </CMSBuilderProvider>
      </TinaConfig>
    </PageProvider>
  );

};

export default CMSProvider;


CMSProvider.propTypes = {
  NotFound: PropTypes.any,
  children: PropTypes.any,
  initSettings: PropTypes.object
};

CMSProvider.defaultProps = {
  initSettings: {}
};
